import { MyAccountHeaderBarContainer } from "../AuthNav";
import { Navigation, UNKNOWN_MENU_INDEX } from "../Navigation";
import * as React from "react";
import { IMenuItem } from "../Navigation/IMenuItem";
import navStructureResidential from "../AuthNav/navStructure.residential.json";
import toolbarItemsResidential from "../AuthNav/toolbarItems.residential.json";
import navStructureSME from "../AuthNav/navStructure.sme.json";
import toolbarItemsSME from "../AuthNav/toolbarItems.sme.json";
import navStructureInitial from "../AuthNav/navStructure.initial.json";
import toolbarItemsInitial from "../AuthNav/toolbarItems.initial.json";

interface INavigationHeaderProps {
  showHeader: boolean;
  authenticated: boolean;
  customerCode?: string;
  nav: IMenuItem[];
}

export const NavigationHeader = (props: INavigationHeaderProps) => {
  const { showHeader, authenticated, customerCode, nav } = props;
  return showHeader ? (
    authenticated ? (
      <MyAccountHeaderBarContainer {...getHeaderBarProps(customerCode)} />
    ) : (
      <Navigation
        menuItems={nav}
        activeDropdownMenuIndex={UNKNOWN_MENU_INDEX}
        activeTopMenuIndex={UNKNOWN_MENU_INDEX}
      />
    )
  ) : null;
};

const getHeaderBarProps = (customerCode?: string) => {
  switch (customerCode) {
    case "RESI":
      return {
        logoutUrl: "/for-home/my-account/logout.html",
        navStructure: navStructureResidential,
        toolbarItems: toolbarItemsResidential,
        customerCode
      };

    case "SME":
      return {
        logoutUrl: "/for-business/my-account/logout.html",
        navStructure: navStructureSME,
        toolbarItems: toolbarItemsSME,
        customerCode
      };

    default:
      return {
        logoutUrl: "#",
        navStructure: navStructureInitial,
        toolbarItems: toolbarItemsInitial,
        customerCode
      };
  }
};
